<template>
  <div :class="themeIsDark ? 'bg-black text-white' : 'bg-white text-black'">
    <div
      class="max-h-300 flex justify-center items-start overflow-hidden mb-12"
    >
      <img class="w-full object-cover" :src="imageUrl" />
    </div>
    <div class="relative z-10">
      <p class="text-xl text-center mb-8 px-20" :style="$themeStyle">{{ title }}</p>
      <p class="text-sm text-center px-20 mb-10" :style="$themeStyle">{{ text }}</p>
      <a
        class="mx-auto px-10"
        :href="buttonLink"
        target="_blank"
        @click="onButtonClick"
        data-umg-event-type="ShopLink"
        :data-umg-target="buttonLinkShopeName"
        :data-umg-variant="title"
        :data-umg-type="buttonLinkType"
      >
        <Button :title="button" />
      </a>
    </div>
  </div>
</template>

<script lang="ts">
import { TranslationHandler } from '../../mixins/translation-handler'
import { PageModule, PageModuleDataAdvert } from '@/types'
import { Component, Prop, Mixins } from 'vue-property-decorator'
import { Getter } from 'vuex-class'
import { ThemeHandler } from '../../mixins/theme-handler'
import cms from '@/cms'
import { ActionClickout } from 'umg-cms-js-sdk/src/tracking/types'

@Component({
  components: {
  }
})
export default class ModuleCard extends Mixins(TranslationHandler, ThemeHandler) {
  @Prop() pageModule!: PageModule<PageModuleDataAdvert>

  @Getter themeIsDark!: boolean
  @Getter themePrimaryColor!: string

  onButtonClick () {
    cms.tracking.trackClickout('shop_clickout', {
      clickout_type: (this.buttonLinkType as ActionClickout),
      shop_name: this.buttonLinkShopeName,
    })
  }

  get buttonLinkType () {
    return this.pageModule.data[this.$tLocaleCurrent].buttonLinkType
  }

  get buttonLinkShopeName () {
    return this.pageModule.data[this.$tLocaleCurrent].buttonLinkShopeName
  }

  get imageUrl () {
    return this.pageModule.data[this.$tLocaleCurrent].imageUrl
  }

  get title () {
    return this.pageModule.data[this.$tLocaleCurrent].title
  }

  get text () {
    return this.pageModule.data[this.$tLocaleCurrent].text
  }

  get buttonLink () {
    return this.pageModule.data[this.$tLocaleCurrent].buttonLink
  }

  get button () {
    return this.pageModule.data[this.$tLocaleCurrent].button
  }
}
</script>
